// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".modal-content[data-v-f4f8d070]{max-width:auto;min-width:50vw}.label[data-v-f4f8d070]{margin-top:1rem}.submit-button[data-v-f4f8d070]{margin-top:2rem}.input[data-v-f4f8d070]{margin-bottom:0}", ""]);
// Exports
module.exports = exports;
